// extracted by mini-css-extract-plugin
module.exports = {"login":"index_login_7xV6u","loginContent":"index_loginContent_216Ja","input":"index_input_qoA6R","button":"index_button_2KucL"};